// extracted by mini-css-extract-plugin
module.exports = {"grid":"custom-infinite-hits_grid__KUSeB","tile":"custom-infinite-hits_tile__Wynzv","hitsWrapper":"custom-infinite-hits_hitsWrapper__VXqK4"};